export default __webpack_public_path__ + "static/media/alert_icon_error.f8bad7f6.svg";